(ns ui.view.sheets.event
  (:require
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [ui.fx.timeout :as timeout]
   [ui.view.sheets.model :as model]))

(def sheet-counter* (atom 0))

(rf/reg-cofx
 ::generate-sheet-id
 (fn [cofx]
   (assoc cofx :sheet-id (swap! sheet-counter* inc))))

(rf/reg-event-fx
 ::open-sheet
 [rf/trim-v
  (rf/inject-cofx ::generate-sheet-id)]
 (fn [{:keys [db] :as cofx} [{:keys [sheet-key sheet-group props state width] :as args}]]
   (let [sheet-id (if (contains? args :sheet-id)
                    (:sheet-id args)
                    (:sheet-id cofx))
         prev-stack (get-in db model/sheet-stack-full-path [])
         sheet-state-path (model/sheet-state-full-path sheet-id)
         new-sheet {:id               sheet-id
                    :open?            true
                    :props            props
                    :sheet-key        sheet-key
                    :sheet-group      sheet-group
                    :sheet-state-path sheet-state-path
                    :width            (or width "50%")}
         new-stack (-> new-sheet
                       (cons prev-stack)
                       vec)
         new-db (-> db
                    (assoc-in model/sheet-stack-full-path new-stack)
                    (assoc-in sheet-state-path (or state {})))]
     {:db new-db})))

(rf/reg-event-fx
 ::remove-sheet
 [rf/trim-v]
 (fn [{:keys [db]} [sheet-id]]
   (let [prev-stack (get-in db model/sheet-stack-full-path [])
         new-stack (->> prev-stack
                        (remove #(= (:id %) sheet-id))
                        vec)
         new-db (cond-> db
                        true (p/dissoc-in (model/sheet-state-full-path sheet-id))
                        (seq new-stack) (assoc-in model/sheet-stack-full-path new-stack)
                        (empty? new-stack) (p/dissoc-in model/sheet-stack-full-path))]
     {:db new-db})))

(rf/reg-event-db
 ::remove-group-sheets
 [rf/trim-v]
 (fn [db [sheet-group]]
   (let [prev-stack (get-in db model/sheet-stack-full-path [])
         sheets-to-remove (->> prev-stack
                               (filterv #(= (:sheet-group %) sheet-group)))
         sheet-ids-to-remove (->> sheets-to-remove
                                  (mapv :id))
         new-stack (->> prev-stack
                        (remove #(= (:sheet-group %) sheet-group))
                        vec)
         prev-sheet-states (get-in db model/sheet-states-full-path {})
         new-sheet-states (apply dissoc prev-sheet-states sheet-ids-to-remove)
         new-db (cond-> db
                        (seq new-sheet-states) (assoc-in model/sheet-states-full-path new-sheet-states)
                        (empty? new-sheet-states) (p/dissoc-in model/sheet-states-full-path)
                        (seq new-stack) (assoc-in model/sheet-stack-full-path new-stack)
                        (empty? new-stack) (p/dissoc-in model/sheet-stack-full-path))]
     new-db)))

(rf/reg-event-fx
 ::close-sheet
 [rf/trim-v]
 (fn [{:keys [db]} [sheet-id]]
   (let [prev-stack (get-in db model/sheet-stack-full-path [])
         new-stack (->> prev-stack
                        (mapv (fn [sheet]
                                (if (= (:id sheet) sheet-id)
                                  (assoc sheet :open? false)
                                  sheet))))
         new-db (assoc-in db model/sheet-stack-full-path new-stack)]
     {:db               new-db
      ::timeout/timeout {:id      (str "remove-sheet-from-stack-" sheet-id)
                         :wait-ms 500
                         :event   [::remove-sheet sheet-id]}})))
